export default __webpack_public_path__ + "static/media/icon-product-design.24571043.svg";